import { V_FORM_ENUM } from '@/CommonDP/VForm/utils';
export const V_FORM_PRJ_ENUM = {
  format_name: '{prjName}',
  format_code_name: '{prjCode}-{prjName}'
};
export const schema = {
  group: V_FORM_ENUM.custom, // 组件类型
  type: 'jy-prj', // 唯一名称
  icon: 'html-text',
  label: '项目名称',
  formItemFlag: true, // 是否需嵌套于el-form-item
  component: require('./prjId.vue').default,
  props() {
    return {
      prjName: () => import('./setting.vue')
    };
  },
  options: {
    name: '',
    label: '项目名称',
    labelHidden: false,
    labelWidth: '',
    position: '',
    labelAlign: '',
    labelWrap: false, // 自动换行
    disabled: false,
    hidden: false,
    required: false,
    requiredHint: ' ',
    size: '',
    columnWidth: '200px',
    // -----
    prjName: '',
    prjCode: '',
    format: V_FORM_PRJ_ENUM.format_code_name
  }
};
